import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiMutationHook } from '../../../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../../../common/queryClient/getMutationFn';
import { AlgorithmUrl } from '../../query/AlgorithmUrl';
import {
  AlgorithmFilterClauseFormDataType,
  AlgorithmFilterClauseValidFormDataType,
} from '../schema/types';

const putAlgorithmFilterClause = (
  id: number,
  algorithmFilterClause: Partial<AlgorithmFilterClauseValidFormDataType>,
  headers?: HttpHeaders
) =>
  apiClient
    .put<AlgorithmFilterClauseFormDataType>(
      expand(AlgorithmUrl.FILTER_CLAUSE, { id }),
      algorithmFilterClause,
      headers ? { headers } : undefined
    )
    .then((response) => response.data);

export const useMutateAlgorithmFilterClauseQuery = createApiMutationHook(
  ['algorithmFilterClause'],
  getMutationFn(undefined, putAlgorithmFilterClause)
);
